import { render } from "./PreFacturaTable.vue?vue&type=template&id=981368f2&scoped=true"
import script from "./PreFacturaTable.vue?vue&type=script&lang=js"
export * from "./PreFacturaTable.vue?vue&type=script&lang=js"

import "./PreFacturaTable.vue?vue&type=style&index=0&id=981368f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-981368f2"]])

export default __exports__